import { useEffect, useMemo, useRef } from 'react';
import { getDefaultRequestForWidget } from '@sitecore-search/core';
import { SubQuery } from '../query.js';
import useBaseWidget from './useBaseWidget.js';
import useQuery from './useQuery.js';
const useSubQuery = (query, initializer) => {
    const { rfkId, instanceId } = useBaseWidget();
    const onParentUpdateCallback = useRef(null);
    const initializerRef = useRef((subQuery) => {
        if (typeof initializer === 'function') {
            initializer(subQuery);
        }
    });
    const subQuery = useMemo(() => {
        const request = getDefaultRequestForWidget(rfkId);
        const newQuery = new SubQuery(query, request);
        newQuery.setDebounceBy('subQuery', instanceId);
        initializerRef.current(newQuery);
        return newQuery;
    }, [query, rfkId, instanceId]);
    useEffect(() => {
        query.onUpdate(() => {
            if (onParentUpdateCallback.current) {
                onParentUpdateCallback.current(subQuery, query);
            }
        });
        return () => {
            subQuery.destroy();
        };
    }, [subQuery, query]);
    const queryResult = useQuery(subQuery);
    return {
        query: subQuery,
        queryResult,
        onParentUpdate: (callback) => {
            onParentUpdateCallback.current = callback;
        },
    };
};
export default useSubQuery;
